import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.apply.complete');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const WizRoute: any;

@Component({
    selector: 'wiz-page-apply-complete',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.apply.complete/view.scss */
:host {
  display: block;
}`],
})
export class PageApplyCompleteComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public application_id: string = '';

    public async ngOnInit() {
        await this.service.init();
        this.application_id = WizRoute.segment.no || '';
        await this.service.render();
    }

    public copyId() {
        navigator.clipboard.writeText(this.application_id);
        this.service.alert.show({
            title: '복사됨',
            message: `접수번호 ${this.application_id} 가 클립보드에 복사되었습니다.`,
            action: '확인',
            actionBtn: 'success',
            cancel: false,
        });
    }
}

export default PageApplyCompleteComponent;